import { Fragment, useContext } from "react";
import PropTypes from "prop-types";
import OfferList from "./OfferList.jsx";
import AvailableDurations from "app/pages/.shared/AvailableDurations";
import Loader from "app/pages/.shared/Loader.jsx";
import PaymentDescriptionTermsContainer from "app/pages/Booking/Payment/PaymentDescriptionTerms/PaymentDescriptionTermsContainer";
import DepositDescriptionTermsContainer from "app/pages/Booking/Payment/PaymentDescriptionTerms/DepositDescriptionTermsContainer";
import AppGlobalsContext from "app/AppGlobalsContext";

export const SearchEngineOffers = ({
	prePackageOffers = [],
	onOfferChange,
	allAvailableDurations = [],
}) => {
	const hasPrepackageOffers = prePackageOffers.length > 0;
	const { shop } = useContext(AppGlobalsContext);
	return (
		<div className="search-engine__offer">
			{(hasPrepackageOffers && (
				<Fragment>
					<OfferList offers={prePackageOffers} onOfferChange={onOfferChange} />
				</Fragment>
			)) || (
				<div className="search-engine__loader">
					<Loader />
				</div>
			)}

			{shop === "en-GB" ? (
				<DepositDescriptionTermsContainer />
			) : (
				<PaymentDescriptionTermsContainer />
			)}

			{allAvailableDurations.length > 1 && (
				<div className="search-engine__available-durations">
					<AvailableDurations durations={allAvailableDurations} />
				</div>
			)}
		</div>
	);
};

SearchEngineOffers.propTypes = {
	prePackageOffers: PropTypes.array,
	onOfferChange: PropTypes.func,
	allAvailableDurations: PropTypes.arrayOf(PropTypes.number),
};
